import { render, staticRenderFns } from "./PhoneNumberSetupTransaction.vue?vue&type=template&id=1586bc54"
import script from "./PhoneNumberSetupTransaction.vue?vue&type=script&lang=js"
export * from "./PhoneNumberSetupTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports